<section class="trusted-requests-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle">
    <div header-actions class="trusted-requests-page__meta">
      <span>{{ requests.length }} solicitação(ões)</span>
      <button class="admin-btn admin-btn--secondary" type="button" (click)="fetchRequests()" [disabled]="isLoading">
        Atualizar
      </button>
    </div>
  </app-admin-page-header>

  <p class="trusted-requests-message trusted-requests-message--success" *ngIf="actionMessage">
    {{ actionMessage }}
  </p>
  <p class="trusted-requests-message trusted-requests-message--error" *ngIf="actionError">
    {{ actionError }}
  </p>

  <div class="trusted-requests-table-wrapper admin-surface">
    <p-table [value]="requests" [loading]="isLoading" [showLoader]="false">
      <ng-template pTemplate="header">
        <tr>
          <th>Solicitação</th>
          <th>Usuário</th>
          <th>Alerta</th>
          <th>Requisitos</th>
          <th>Elegível</th>
          <th>Ações</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-request>
        <tr>
          <td>
            <div class="trusted-requests-table__stack">
              <strong>#{{ request.id }}</strong>
              <small>{{ formatRequestedAt(request.requested_at) }}</small>
              <span class="trusted-requests-chip">{{ request.status }}</span>
            </div>
          </td>
          <td>
            <a
              class="trusted-requests-user"
              [routerLink]="['/dashboard/users-info', request.user_id]"
              target="_blank"
              rel="noopener noreferrer">
              <strong>{{ getUserDisplay(request) }}</strong>
              <small>{{ request.email || '-' }}</small>
              <small>ID {{ request.user_id }}</small>
            </a>
          </td>
          <td>
            <span
              class="trusted-requests-alert"
              [class.trusted-requests-alert--active]="request.has_active_alert">
              {{ request.has_active_alert ? 'Com alerta ativo' : 'Sem alerta ativo' }}
            </span>
          </td>
          <td>
            <div class="trusted-requests-requirements">
              <span [class.trusted-requests-requirement--done]="request.kyc_completed">
                KYC: {{ request.kyc_completed ? 'concluído' : 'pendente' }}
              </span>
              <span [class.trusted-requests-requirement--done]="isCoinPurchaseComplete(request)">
                Compras: {{ getCurrencyProgressLabel(request.coin_purchase_value, request.coin_purchase_value_target) }}
              </span>
              <span [class.trusted-requests-requirement--done]="request.battle_count >= request.battle_target">
                Partidas: {{ getProgressLabel(request.battle_count, request.battle_target) }}
              </span>
              <span [class.trusted-requests-requirement--done]="request.cashout_count >= request.cashout_target">
                Saques: {{ getProgressLabel(request.cashout_count, request.cashout_target) }}
              </span>
            </div>
          </td>
          <td>
            <span class="trusted-requests-eligibility" [class.trusted-requests-eligibility--yes]="request.is_eligible">
              {{ request.is_eligible ? 'Sim' : 'Não' }}
            </span>
          </td>
          <td>
            <div class="trusted-requests-actions">
              <button
                class="admin-btn admin-btn--success"
                type="button"
                (click)="approveRequest(request)"
                [disabled]="isProcessing(request.id)">
                {{ isProcessing(request.id) ? 'Processando...' : 'Aprovar' }}
              </button>
              <button
                class="admin-btn admin-btn--danger"
                type="button"
                (click)="rejectRequest(request)"
                [disabled]="isProcessing(request.id)">
                Reprovar
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="trusted-requests-table__empty-message">
            <div *ngIf="isLoading" class="trusted-requests-empty-state">
              <p-progressSpinner ariaLabel="Carregando solicitações Trusted" strokeWidth="6"></p-progressSpinner>
              <span>Carregando solicitações...</span>
            </div>
            <div *ngIf="!isLoading" class="trusted-requests-empty-state">
              <i class="pi pi-shield"></i>
              <span>Nenhuma solicitação Trusted pendente.</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog
    [header]="confirmationTitle"
    [(visible)]="confirmationVisible"
    [modal]="true"
    [appendTo]="'body'"
    [draggable]="false"
    [dismissableMask]="true"
    [style]="{ width: '30rem', maxWidth: '95vw' }"
    styleClass="trusted-requests-confirm-dialog"
    (onHide)="closeConfirmation()">
    <div class="trusted-requests-confirm" *ngIf="selectedRequest as request">
      <div class="trusted-requests-confirm__icon" [class.trusted-requests-confirm__icon--danger]="confirmationAction === 'reject'">
        <i class="pi" [class.pi-check-circle]="confirmationAction === 'approve'" [class.pi-times-circle]="confirmationAction === 'reject'"></i>
      </div>

      <div class="trusted-requests-confirm__content">
        <strong>{{ getUserDisplay(request) }}</strong>
        <span>{{ request.email || 'Sem email informado' }}</span>
        <p>
          Esta ação vai {{ confirmationAction === 'reject' ? 'reprovar' : 'aprovar' }} a solicitação e removê-la da fila de pendências.
        </p>
        <label class="trusted-requests-reject-reason" *ngIf="confirmationAction === 'reject'">
          <span>Motivo da recusa</span>
          <textarea
            name="trustedRevokedReason"
            [(ngModel)]="trustedRevokedReason"
            maxlength="300"
            rows="4"
            placeholder="Descreva o motivo da recusa"
            required></textarea>
          <small>{{ trustedRevokedReason.length }}/300</small>
        </label>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button type="button" class="admin-btn admin-btn--secondary" (click)="closeConfirmation()">
        Cancelar
      </button>
      <button
        type="button"
        [class]="confirmationButtonClass"
        (click)="confirmSelectedAction()"
        [disabled]="isConfirmationDisabled">
        {{ confirmationButtonLabel }}
      </button>
    </ng-template>
  </p-dialog>
</section>
